import { useContext } from 'react';
import FilterContext from './filterContext';

const useFilterContext = () => useContext(FilterContext);

export default useFilterContext;
